import { Elements } from '@stripe/react-stripe-js';
import SignUpForm from "../Components/SignUp/SignUpForm";
import { stripePromise } from '../stripePromise';

const Registerpage = () => {
    return (
        <div className="app-inner-signup">
            <div className="container">
                <div className="content-wrap bg-blue">
                    <div className="content-wrap-inner">
                        <Elements
                            stripe={stripePromise}
                            options={{ fonts: [{ cssSrc: 'https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap' }] }}
                        >
                            <SignUpForm />
                        </Elements>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Registerpage;
